import styled from 'styled-components';
import { borderRadius, colors, verticalGutter } from '../../../styles';

// NOTE: this is reused in `AssetDownloadsTable` component too
// TODO: maybe add an option of non-formik field?
export default styled.div`
  position: relative;
  max-height: 3rem;

  &:after {
    content: '';
    display: block;
    width: 0.6rem;
    height: 0.6rem;
    border: 1px solid ${colors.darkGrey};
    border-width: 1px 1px 0 0;
    transform: rotate(135deg);
    position: absolute;
    top: 1rem;
    right: 1rem;
    pointer-events: none;
  }

  > select.ui.selection.dropdown {
    appearance: none;
    min-width: 100px; /* for no reason, from design */
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  [role='presentation'] {
    position: absolute;
    top: ${borderRadius.small};
    left: ${borderRadius.small};
    padding-left: ${verticalGutter * 0.3}rem;
    width: calc(100% - ${verticalGutter}rem);
    height: calc(100% - ${borderRadius.small} * 2);
    background: ${colors.white};
    line-height: 2.5;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    pointer-events: none;
  }
`;
